var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BasicInput"},[_vm._v("\n\t\t123\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }